import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  const id = props.node.key;
  const value = props.node ? props.node.data[props.colDef.field] : null;
  const checklistId = props.node ? props.node.data['checklistID'] : null;

  if (props.node) {
    const defaultCheckboxClass =
      'ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper';
    let checkboxClass = value
      ? defaultCheckboxClass + ' ag-checked'
      : defaultCheckboxClass;

    return (
      <span>
        <MotifCheckbox
          type="checkbox"
          name="cell-checkbox"
          id={`ag-cell-checkbox-${id}`}
          checked={value}
          tabindex="-1"
          data-testid="selectCheckboxHeader"
          aria-label="Press Space to toggle row selection"
          onClick={() => props.onCellCheckboxChange(checklistId, props.node)}
        ></MotifCheckbox>
      </span>
    );
  }

  return null;
};
